import { useCallback } from 'react'
import log from 'loglevel'
import { ControlServicePromiseClient } from '@trustero/trustero-api-web/lib/model/control_grpc_web_pb'
import { PolicyPromiseClient } from '@trustero/trustero-api-web/lib/model/policy_grpc_web_pb'
import {
  Control,
  DismissControlRequest,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { StringList } from '@trustero/trustero-api-web/lib/common/collections_pb'
import { useAuthorizedGrpcClient } from '../../../../adapter'
import { useInvalidatePolicyCache } from '../../policy/usePolicy'
import { useRemoveControlFromAllAudits } from '../audit'
import { useInvalidateControlsCache } from './useControls'

/**
 * TODO: Logic should be  moved to the backend once the multi-audit flag is
 * @param controlId
 */
export const useDeleteControl = ({
  control: { id },
}: {
  control: Control.AsObject
}): (() => Promise<void>) => {
  const invalidatePolicyCache = useInvalidatePolicyCache()
  const invalidateControlsCache = useInvalidateControlsCache()
  const controlClient = useAuthorizedGrpcClient(ControlServicePromiseClient)
  const policyClient = useAuthorizedGrpcClient(PolicyPromiseClient)
  const removeFromAllAudits = useRemoveControlFromAllAudits(id ?? '')

  return useCallback(async () => {
    try {
      const dismissPromise = controlClient
        .dismissControl(new DismissControlRequest().setControlId(id))
        .then(() => {
          return
        })
      const removeFromAuditPromise = removeFromAllAudits()
      const removeFromPolicyPromise = policyClient
        .disassociateControlFromPolicy(new StringList().setItemList([id]))
        .then(() => {
          return
        })

      await Promise.all([
        dismissPromise,
        removeFromAuditPromise,
        removeFromPolicyPromise,
      ])

      await invalidatePolicyCache()
      await invalidateControlsCache()
    } catch (e) {
      log.error('Caught an error while attempting to remove the control', e)
    }
  }, [
    controlClient,
    removeFromAllAudits,
    policyClient,
    id,
    invalidatePolicyCache,
    invalidateControlsCache,
  ])
}
